

export const formatDateDQ = (date) => {
    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:00`;
};

export function getYesterdayDateString() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(yesterday.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export function getUTCDatesFromTo(hoursAgo) {
    // Get the current date and time
    const now = new Date();

    // Create a new date for 1 hour ago
    const oneHourAgo = new Date(now.getTime() - hoursAgo * 60 * 60 * 1000);

    // Function to format a date to UTC string in the desired format
    function formatToUTC(date) {
        return date.toISOString().split('Z')[0] + 'Z';
    }

    // Format both dates to UTC
    const nowUTC = formatToUTC(now);
    const hourAgoUTC = formatToUTC(oneHourAgo);

    return { hourAgoUTC, nowUTC };
}

export function getUTCDatesFromParams(from, to) {
    // Function to format a date to UTC string in the desired format
    function formatToUTC(date) {
        return date.toISOString().split('Z')[0] + 'Z';
    }

    // Parse the input date strings
    const date1 = new Date(from);
    const date2 = new Date(to);

    // Format both dates to UTC
    const date1UTC = formatToUTC(date1);
    const date2UTC = formatToUTC(date2);

    return { date1UTC, date2UTC };
}

export function getDayStartAndEndISO(dateStr) {
  // Parse the input as a UTC date
  const [year, month, day] = dateStr.split('-').map(Number);

  // Start of day (00:00:00.000)
  const start = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));

  // End of day (23:59:59.999)
  const end = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));

  const format = (d) => d.toISOString().split('Z')[0] + 'Z';

  return {
    startISO: format(start),
    endISO: format(end),
  };
}
export function getDayRangeISO(dateString) {
    const date = new Date(dateString);

    // Start of the day (00:00:00)
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);

    // End of the day (23:59:59)
    const end = new Date(date);
    end.setHours(23, 59, 59, 999); // 999 ms to represent full last second

    const format = (d) => d.toISOString().split('Z')[0] + 'Z';

    return {
        startISO: format(start),
        endISO: format(end),
    };
}

export function adjustDatesLast24Table(fromDate, toDate) {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const to = new Date(toDate);

    // Check if 'to' date is today
    if (to.toDateString() === today.toDateString()) {
        const from = new Date(fromDate);
        const diff = to - from;
        const hoursDifference = diff / (1000 * 60 * 60);

        // If from date is less than 24 hours before to date, adjust it
        if (hoursDifference < 24) {
            from.setTime(to.getTime() - 24 * 60 * 60 * 1000);
        }

        return {
            from: from.toISOString().split('T')[0],
            to: to.toISOString().split('T')[0]
        };
    }

    return {
        from: new Date(fromDate).toISOString().split('T')[0],
        to: new Date(toDate).toISOString().split('T')[0]
    };
}